import React from 'react';

import { NavLink as RouterNavLink } from 'react-router-dom';

// An ugly hack, but Radix otherwise overrides the className in the NavLink as a string
type RouterNavLinkExtraProps = {
    routerClassName: (props: { isActive: boolean }) => string;
};
const NavLink = React.forwardRef<
    React.ElementRef<typeof RouterNavLink>,
    React.ComponentPropsWithoutRef<typeof RouterNavLink> & RouterNavLinkExtraProps
>(({ routerClassName, ...props }, forwardedRef) => {
    return <RouterNavLink {...props} className={(props) => `${routerClassName(props)}`} ref={forwardedRef} />;
});
NavLink.displayName = 'NavLink';

export default NavLink;
